import React from "react";
import ContentTypesPicture from "../../assets/images/iphone-mockups/BZ7H3OVK.png";
import "./ContentTypes.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStore,
  faImage,
  faMugHot,
  faQuoteRight,
} from "@fortawesome/free-solid-svg-icons";
import PhoneImage from "../PhoneImage/PhoneImage";

const ContentTypes = () => {
  return (
    <div>
      <div className="content-types-section">
        <div className="content-info">
          <h2 className="content-title">Make It Yours</h2>
          <p className="content-description">
            Customize your Coffeehouse to match your vibe
          </p>
        </div>

        <div className="content-types-grid">
          <div className="content-type-item">
            <FontAwesomeIcon icon={faStore} />
            <span className="content-type-name">Name</span>
          </div>

          <div className="content-type-item">
            <FontAwesomeIcon icon={faImage} />
            <span className="content-type-name">Picture</span>
          </div>

          <div className="content-type-item">
            <FontAwesomeIcon icon={faMugHot} />
            <span className="content-type-name">Custom Drinks</span>
          </div>

          <div className="content-type-item">
            <FontAwesomeIcon icon={faQuoteRight} />
            <span className="content-type-name">Timer Messages</span>
          </div>
        </div>

        <div className="phone">
          <PhoneImage src={ContentTypesPicture} />
        </div>
      </div>
    </div>
  );
};

export default ContentTypes;
